/*** Set Detail Page Banner Start ***/
function setDetailPageBanner(diamond_type){
  if(diamond_type == ''){
    $(".tps-color-diamond-detail-banner-section").hide();
  }else{
    $(".tps-white-diamond-detail-banner-section").hide();
  }
}
/*** Set Detail Page Banner End ***/

/*** Set Back To Search URL Start ***/ 
function changeBreadcrumUrl(diamond_type,diamondData) {
  if(diamond_type == 'natural-white' || diamond_type == 'natural-fancy'){
    if(diamondData.fancyColor == ''){
      $("#tps_back_to_search").attr("href", tps_config.urls.loose_diamond);
      $("#tps_breadcrumbs_second_link").attr("href", tps_config.urls.loose_diamond);
    }else{
      $("#tps_back_to_search").attr("href", tps_config.urls.loose_color_diamond);
      $("#tps_breadcrumbs_second_link").attr("href", tps_config.urls.loose_color_diamond);
    }    
  }else if(diamond_type == 'lab'){
    if(diamondData.fancyColor == ''){
      $("#tps_back_to_search").attr("href", tps_config.urls.lab_diamond);
      $("#tps_breadcrumbs_second_link").attr("href", tps_config.urls.lab_diamond);
    }else{
      $("#tps_back_to_search").attr("href", tps_config.urls.lab_color_diamond);
      $("#tps_breadcrumbs_second_link").attr("href", tps_config.urls.lab_color_diamond);
    }
  } 
}
 
/*** End ***/

/*** Get Daimond ID From Url Start ***/
function getURLParameterByName(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(location.search);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}    
/*** End ***/

/*** Get Diamond Detail Page Meta Title Information ***/
function getDiamondDetailMetaTitle(diamondData,diamondType,shopName) {
  var page_meta_title = diamondData.caratWeight+" "+translations.titleCarat+" "+diamondData.shape+" "+translations.titleShape+" "+diamondType+" "+translations.titleDiamond+" | "+diamondData.lab+" "+translations.titleCertified+" - "+shopName; 
  return page_meta_title;
}
/*** End ***/

/*** Get Diamond Detail Page Meta Descripion Information ***/
function getDiamondDetailMetaDesc(diamondData,diamondType,shopName) {
  var page_meta_description = translations.titleShopForA+" "+diamondData.caratWeight+ " "+translations.titleCarat.toLowerCase()+" "+diamondData.shape.toLowerCase()+" "+diamondType.toLowerCase()+" "+translations.titleDiamondAt+" "+shopName+". "+translations.titleThisDiamondIsCertifiedBy+" "+diamondData.lab+", "+translations.titleFeaturingA+" "+diamondData.clarity+" "+translations.titleAnd+" "+diamondData.color+" "+translations.titleColorRating+".";
  return page_meta_description;
}
/*** End ***/

/*** Get Diamond Description Information ***/
function getDiamondDesc(diamondData,diamondType) {  
  var dia_description = translations.titleThis+" " + diamondData.caratWeight + " "+translations.titleCarat.toLowerCase()+", " + diamondData.color + " "+translations.titleColorDiamondRatedAsHaving+" " + diamondData.clarity + " "+translations.titleClarityWithA+" " + diamondData.shape.toLowerCase() + " "+translations.titleShapeSuppliedWithA+" " + diamondData.lab + " "+translations.titleGradingReport.toLowerCase()+".";
  return dia_description;
}
/*** End ***/

/*** Get Diamond Three C Information ***/
function getDiamondThreeCInfo(diamondData,diamondType) {
  var diamond_certificate_url = getCertificateUrl(diamondData);
  
  var diamond_threec_info = '<ul>';
  if(diamondData.color != ''){
     diamond_threec_info += '<li>' + diamondData.color + ' '+translations.titleColor+'</li>';
  }  
  diamond_threec_info += '<li>' + diamondData.clarity + ' '+translations.titleClarity+'</li>';
  if(diamondData.cut != '' && diamondData.cut != 'Na' && diamondData.cut != 'NA'){
    diamond_threec_info += '<li>' + diamondData.cut + ' '+translations.titleCut+'</li>';
  }
  diamond_threec_info += '<li><span class="tps_'+diamondData.lab.toLowerCase()+'_icon"></span><a href="'+diamond_certificate_url+'" target="_blank">' + diamondData.lab + ' '+translations.titleReport+'</a></li></ul>';
  return diamond_threec_info;
}
/*** End ***/

/*** Get Diamond Detail Information ***/
function getDiamondDetailInfo(diamondData) {  
  var diamondInformation = getDiamondInformationLayout(diamondData);
  
  var detailInfo = '';  
  detailInfo += '<div class="tps-diamond-details">';
  detailInfo += '<div class="tps-diamond-detail-section-heading active"><h2>'+translations.titleDiamondDetails+'</h2><span class="tps-tab-arrow tps-arrow-up"></span></div>';
  detailInfo += '<div class="tps-diamond-details-info">';   
  detailInfo += diamondInformation;
  detailInfo += '</div>';
  detailInfo += '</div>';
  return detailInfo;
}
/*** End ***/

/*** Diamond detail Info Open Close ***/
$(document).on("click", ".tps-diamond-detail-section-heading", function() {
  if(jQuery(this).hasClass('active')){
    jQuery(this).removeClass('active');
    jQuery('.tps-tab-arrow').addClass('tps-arrow-down').removeClass('tps-arrow-up');
    jQuery('.tps-tab-arrow').addClass('tps-arrow-down').removeClass('tps-arrow-up');
    jQuery('.tps-diamond-details-info').slideUp('slow');
  }else{
    jQuery(this).addClass('active');
    jQuery('.tps-tab-arrow').addClass('tps-arrow-up').removeClass('tps-arrow-down');
    jQuery('.tps-diamond-details-info').slideDown('slow');
  }    
});
/*** End ***/

/*** Get Diamond Grid View Gallery ***/
function getGridViewGallery(diamondData,imageUrls,threedEnable,handSliderEnable,canvasImagesEnable) {
  var diamond_type = getDiamondType(diamondData.diamondType);    
  var diamond_title = getDiamondName(diamondData,diamond_type);
  var diamondStockImage = [];
  var diamondHandSliderImage = [];

  //get diamond stock image url
  $.each(diamondImageUrl, function(i, diamondImage) {   
    if(diamondData.fancyColor == ''){
      var imageParam = diamondData.shape.toLowerCase()+'_generic';
    }else{
      var imageParam = diamondData.shape.toLowerCase()+'_'+diamondData.fancyColor.toLowerCase()+'_generic';
    }     
    
    if(diamondImage.includes(imageParam)){    
      diamondStockImage.push(diamondImage);
    }

    var handSliderDiamondImage = 'hand_slider_'+diamondData.shape.toLowerCase()+'_diamond';
    if(diamondImage.includes(handSliderDiamondImage)){    
      diamondHandSliderImage.push(diamondImage);
    }
  });
  
  var galleryHtml = '';  
  galleryHtml += '<div class="tps-main-slide tps-main-slide-image">';
  galleryHtml += '<div class="tps-slide">';
    if(diamondData.diamondImage != '' && diamondData.diamondImage != 'NA' && diamondData.diamondImage != 'N/A' && diamondData.diamondImage != 'None'){
      galleryHtml += '<img class="tps-diamond-stock-image" src="'+diamondData.diamondImage+'" onerror="imgError(this,`'+diamondStockImage[0]+'`);" title="'+diamond_title+'" alt="'+diamond_title+'" height="400" width="400">';
    }else{         
      galleryHtml += '<img class="tps-diamond-stock-image" src="'+diamondStockImage[0]+'" data-placeholder-img="" alt="'+diamond_title+'" title="'+diamond_title+'" width="400" height="400">';      
    }
  galleryHtml += '</div>';  
  galleryHtml += '</div>';   

  if(diamondData.diamondVideo != '' && diamondData.diamondVideo != 'None'){
    galleryHtml += '<div class="tps-main-slide tps-main-slide-video">';
    galleryHtml += '<div class="tps-slide">';  
    //galleryHtml += '<span class="tps_iframe_loader tps_iframe_loader_show"></span>';
    galleryHtml += getGallery360VideoLayout(diamondData);  
    galleryHtml += '</div>';
    galleryHtml += '</div>';   
  }

  if(threedEnable == 'true'){
    galleryHtml += '<div class="tps-main-slide tps-main-slide-threed-model">';
    galleryHtml += '<div class="tps-slide">';
    galleryHtml += getGalleryThreeDLayout(diamondData);
    galleryHtml += '</div>';
    galleryHtml += '</div>'; 
  }

  if(handSliderEnable == 'true'){
    galleryHtml += '<div class="tps-main-slide tps-main-slide-hand-slider">';
    galleryHtml += '<div class="tps-slide">';
    galleryHtml += getGalleryHandSliderLayout(diamondData,imageUrls,diamondHandSliderImage[0]);
    galleryHtml += '</div>';
    galleryHtml += '</div>';  
  }

  if(canvasImagesEnable == 'true'){
    galleryHtml += '<div class="tps-main-slide tps-main-slide-canvas-front">';
    galleryHtml += '<div class="tps-slide">';
    galleryHtml += '<canvas class="gallery-two tps-canvas-image-front" id="tps_canvas_image_front"></canvas>';
    galleryHtml += '</div>';
    galleryHtml += '</div>'; 
    
    galleryHtml += '<div class="tps-main-slide tps-main-slide-canvas-side">';
    galleryHtml += '<div class="tps-slide">';
    galleryHtml += '<canvas class="gallery-three tps-canvas-image-side" id="tps_canvas_image_side"></canvas>';
    galleryHtml += '</div>';
    galleryHtml += '</div>';      
  }
  
  return galleryHtml;
}
/*** End ***/

/*** Get Diamond Grid View Gallery ***/
function getThumbSliderGallery(diamondData,imageUrls,threedEnable,handSliderEnable,canvasImagesEnable) {
  var diamond_type = getDiamondType(diamondData.diamondType);    
  var diamond_title = getDiamondName(diamondData,diamond_type);
  var mainImageGallery = getGridViewGallery(diamondData,imageUrls,threedEnable,handSliderEnable,canvasImagesEnable);
  var thumbImageGallery = getThumbnailGalleryLayout(diamondData,imageUrls,threedEnable,handSliderEnable,canvasImagesEnable);

  var galleryHtml = '';
  galleryHtml += '<div class="tps-main-image-slide">';
  galleryHtml += mainImageGallery;
  galleryHtml += '</div>';

  galleryHtml += '<div class="tps-thumb-image-slide">';
  galleryHtml += thumbImageGallery;
  galleryHtml += '</div>';    
  return galleryHtml;
}
/*** End ***/

/*** Get Diamond Gallery Thumbnail Layout ***/
function getThumbnailGalleryLayout(diamondData,imageUrls,threedEnable,handSliderEnable,canvasImagesEnable) {
  var diamond_title = getDiamondName(diamondData,diamond_type);
  var diamondStockImage = [];
  var modalStockImage = [];

  //get diamond stock image url
  $.each(diamondImageUrl, function(i, diamondImage) {      
    if(diamondData.fancyColor == ''){
      var imageParam = diamondData.shape.toLowerCase()+'_generic';
    }else{
      var imageParam = diamondData.shape.toLowerCase()+'_'+diamondData.fancyColor.toLowerCase()+'_generic';
    }  
    
    if(diamondImage.includes(imageParam)){    
      diamondStockImage.push(diamondImage);
    }

    var modalImageParam = '3d_'+diamondData.shape.toLowerCase()+'_diamond';
    if(diamondImage.includes(modalImageParam)){    
      modalStockImage.push(diamondImage);
    }    
  });
  
  var galleryThumbHtml = '';
  galleryThumbHtml += '<div class="tps-thumb-slide tps-thumb-slide-image">';
  galleryThumbHtml += '<div class="tps-thumb">';
  if(diamondData.diamondImage != '' && diamondData.diamondImage != 'NA' && diamondData.diamondImage != 'None' && diamondData.diamondImage != 'N/A'){
    galleryThumbHtml += '<img src="'+diamondData.diamondImage+'" onerror="imgError(this,`'+diamondStockImage[0]+'`);" title="'+diamond_title+'" alt="'+diamond_title+'" height="auto" width="auto">';
  }else{      
    galleryThumbHtml += '<img class="tps-thumb-image" src="'+diamondStockImage[0]+'" data-placeholder-img="" alt="'+diamond_title+'" title="'+diamond_title+'" width="auto" height="auto">';           
  }
  galleryThumbHtml += '</div>';  
  galleryThumbHtml += '</div>';   

  if(diamondData.diamondVideo != '' && diamondData.diamondVideo != 'None'){
    galleryThumbHtml += '<div class="tps-thumb-slide tps-thumb-slide-image">';
    galleryThumbHtml += '<div class="tps-thumb">'; 
    galleryThumbHtml += '<span class="tps-video-play-icon"></span>';     
    galleryThumbHtml += '<img class="tps-thumb-image" src="'+diamondStockImage[0]+'" data-placeholder-img="" alt="'+diamond_title+'" title="'+diamond_title+'" width="auto" height="auto">';    
    galleryThumbHtml += '</div>';
    galleryThumbHtml += '</div>';  
  }

  if(threedEnable == 'true'){
    galleryThumbHtml += '<div class="tps-thumb-slide tps-thumb-slide-image">';
    galleryThumbHtml += '<div class="tps-thumb">';
    galleryThumbHtml += '<img src="'+modalStockImage[0]+'" title="'+diamond_title+'" alt="'+diamond_title+'" height="auto" width="auto">';
    galleryThumbHtml += '</div>';
    galleryThumbHtml += '</div>'; 
  }

  if(handSliderEnable == 'true'){
    galleryThumbHtml += '<div class="tps-thumb-slide tps-thumb-slide-image">';
    galleryThumbHtml += '<div class="tps-thumb">';
    galleryThumbHtml += '<img src="'+imageUrls.handSliderImage+'" onClick="renderSliders(`'+diamondData.caratWeight+'`)" title="'+diamond_title+'" alt="'+diamond_title+'" height="auto" width="auto">';
    galleryThumbHtml += '</div>';
    galleryThumbHtml += '</div>';  
  }

  if(canvasImagesEnable == 'true'){
    galleryThumbHtml += '<div class="tps-thumb-slide tps-thumb-slide-image">';
    galleryThumbHtml += '<div class="tps-thumb">';
    galleryThumbHtml += imageUrls.canvasFrontImage;
    galleryThumbHtml += '</div>';
    galleryThumbHtml += '</div>';  

    galleryThumbHtml += '<div class="tps-thumb-slide tps-thumb-slide-image">';
    galleryThumbHtml += '<div class="tps-thumb">';
    galleryThumbHtml += imageUrls.canvasSideImage;
    galleryThumbHtml += '</div>';
    galleryThumbHtml += '</div>';  
  }
  
  return galleryThumbHtml;
}
/*** End ***/

// function getDiamondThumbStockImage(diamondData) {
//   $.each(diamondImageUrl, function(i, diamondImage) {   
//     if(diamondData.fancyColor == ''){
//       var imageParam = diamondData.shape.toLowerCase()+'_generic.png';
//     }else{
//       var imageParam = diamondData.shape.toLowerCase()+'_'+diamondData.fancyColor.toLowerCase()+'_generic.png';
//     }     
    
//     if(diamondImage.includes(imageParam)){         
//       var thumbImageUrl = diamondImage;
//       return thumbImageUrl;
//     }
//   });
// }

/*** Get Diamond Gallery 360 Video HTML ***/
function getGallery360VideoLayout(diamondData) {
   var video_url = diamondData.diamondVideo;
  
   if(video_url != ''){
    var videoHtml = '';
    if (video_url.indexOf("mp4") > -1 || video_url.indexOf(".mov") > -1) {
      videoHtml ='<video class="tps-dia-gallery-video" controls autoplay playsinline>';
      videoHtml +='<source src="'+video_url+'" type="video/mp4">';
      videoHtml +='</video>';     
    }else{
       videoHtml ='<iframe class="tps-dia-gallery-video-iframe tps-gallery-video-iframe" id="tps_diamond_video_iframe" src="'+video_url+'" scrolling="no"></iframe>';

       //set iframe width as per device
       if (video_url.indexOf("https://loupe360.com/diamond/") > -1){              
          video_url = video_url.replace('/500/500', '/resp/true/autoplay');
          videoHtml ='<iframe class="tps-dia-gallery-video-iframe" id="tps_diamond_video_iframe" src="'+video_url+'" width="500px" height="500px" scrolling="no"></iframe>';
       }        
      
    }
    return videoHtml;
  }  
}
/*** End ***/

/*** Get Diamond 3D Model HTML ***/
function getGalleryThreeDLayout(diamondData) {
  var shape = diamondData.shape;
  var width = diamondData.width;
  var length = diamondData.length;
  var depth = diamondData.depth;  
  var deptPerc = diamondData.deptPerc; 
  var table = diamondData.tablePerc;
  var girdle = diamondData.girdle;
  if(diamondData.girdleMin != '' && diamondData.girdleMax != '' && diamondData.girdleMin != 0 && diamondData.girdleMax != 0){
    var girdle = diamondData.girdleMin+"-"+diamondData.girdleMax;
  }

  var threed_url = '';
  threed_url += 'https://php71.transpacific-software.com/3d_diamond/index.php?getShape='+shape.toLowerCase();
  threed_url += '&getWidth='+width;
  threed_url += '&getLength='+length;
  threed_url += '&getDepth='+deptPerc;
  threed_url += '&getTable='+table;
  if(girdle != '' && girdle != null){
    threed_url += '&getGirdle='+girdle;
  }else{
    threed_url += '&getGirdle=NA';
  }

  if(threed_url != ''){    
    theedHtml ='<iframe class="tps-dia-gallery-threed-model" src="'+threed_url+'" height="400px" width="400px" scrolling="no"></iframe>';	
    return theedHtml;
  }
}
/*** End ***/

/*** Get Gallery Hand Slider Layout ***/
function getGalleryHandSliderLayout(diamondData,imageUrls,handDiamondImage) {
  handSliderHtml = '';
  handSliderHtml += '<div class="tps-diamond-hand-slider">';
  handSliderHtml += '<img id="tps-gallery-thumb-white" class="tps-gallery-hand-slider-white" src="'+imageUrls.handSliderWhite+'" title="Hand slider white image" alt="Hand slider white image" height="auto" width="auto">';
  handSliderHtml += '<img id="tps-gallery-hand-diamond-image" class="tps-gallery-hand-diamond-image" src="'+handDiamondImage+'" title="Hand slider diamond" alt="Hand slider diamond" height="auto" width="auto">';
  handSliderHtml += '<img id="tps-gallery-thumb-black" class="tps-gallery-hand-slider-dark" src="'+imageUrls.handSliderDark+'" title="Hand slider dark image" alt="Hand slider dark image" height="auto" width="auto">';
  handSliderHtml += '</div>';  

  handSliderHtml += '<div class="tps-diamond-hand-carat-slider">';
  handSliderHtml += '<span class="left-slide">0.20 ct.</span>';
  handSliderHtml += '<span class="right-slide">10 ct.</span>';
  handSliderHtml += '<div id="hand-carat-slider" class="caratlearnmore"></div>';  
  handSliderHtml += '<div class="min-carat-detail" id="min_carat_detail"></div>';
  handSliderHtml += '</div>';

  handSliderHtml += '<div class="tps-diamond-hand-color-slider">';
  handSliderHtml += '<span class="left-slide">'+translations.titleLighter+'</span>';
  handSliderHtml += '<span class="right-slide">'+translations.titleDarker+'</span>';
  handSliderHtml += '<div id="hand-color-slider" class="handcolorslider"></div>';  
  handSliderHtml += '</div>';

  setTimeout(function(){
    hand_carat_slider_render(diamondData.caratWeight);
    hand_color_slider_render();
  }, 1000);
  
  return handSliderHtml;   
}
/*** End ***/

/*** Rendar Hand & Carat Slider Start ***/
function renderSliders(diamondCarat) {
    hand_carat_slider_render(diamondCarat);
    hand_color_slider_render();
}
/*** Rendar Hand & Carat Slider End ***/

/*** Gallery Hand Color Slider ***/
function hand_color_slider_render() {
  $("#hand-color-slider").slider({
          step:0.01,
          min: 0.00,
          max: 1.00,
          value: 0.50,
          slide: function(event, ui) {
             var diamondcarat = ui.value;             
             $('#tps-gallery-thumb-black').css('opacity', diamondcarat);              
          },
          change: function(event, ui) {            
            var diamondcarat = ui.value;
            $('#tps-gallery-thumb-black').css('opacity', diamondcarat);  
          },
  });
}
/*** End ***/

/*** Gallery Hand Carat Slider ***/
function hand_carat_slider_render(diamondCarat) {
  const dpiDesktop = 96;        // Common desktop DPI
  const dpiIpad = 264;          // iPad Pro PPI
  const dpiIpadMini = 326;      // iPad Mini PPI
  const dpiHighResPhone = 450;  // High-resolution phone (like iPhone)  
  var diamondcarat = diamondCarat;
      
  $("#hand-carat-slider").slider({
            step: 0.001,
            min: 0.20,
            max: 10,
            value: diamondcarat,
            create: function() {         
                var get_dpiDesktop = caratToPixelSize(diamondcarat, dpiDesktop);

                $('#tps-gallery-hand-diamond-image').css({
                  'width': get_dpiDesktop + 'px',  // Set width to diamond diameter
                  'height': get_dpiDesktop + 'px'  // Set height to diamond diameter (making it square)
                });
              
                jQuery('#min_carat_detail').appendTo(jQuery('#hand-carat-slider a').get(0));
                jQuery('#hand-carat-slider').slider("value", diamondcarat);  
            },
            slide: function(event, ui) {    
                var diamondcarat = ui.value; 
              
                var delay = function() {
                    var handleIndex = jQuery(ui.handle).data('index.uiSliderHandle');
                    jQuery('#min_carat_detail').html(ui.value.toFixed(2)+" ct.");
                };
                setTimeout(delay, 5);
         },
        change: function(event, ui) {              
                var diamondcarat = ui.value;

                var get_dpiDesktop = caratToPixelSize(diamondcarat, dpiDesktop);
                $('#tps-gallery-hand-diamond-image').css({
                  'width': get_dpiDesktop + 'px',  // Set width to diamond diameter
                  'height': get_dpiDesktop + 'px'  // Set height to diamond diameter (making it square)
                });
          
                var delay = function() {
                    var handleIndex = jQuery(ui.handle).data('index.uiSliderHandle');
                    jQuery('#min_carat_detail').html(ui.value.toFixed(2)+" ct.");                         
                };
                setTimeout(delay, 600);
         },
    });
}
/*** End ***/

/*** Function To Convert Carat Weight To Diamond Diameter In mm (adjusted for visual purposes) Start ***/
function caratToMm(caratWeight) {
    return Math.cbrt(caratWeight / 0.0061).toFixed(2); // Return the size in mm
}
/*** Function To Convert Carat Weight To Diamond Diameter In mm (adjusted for visual purposes) End ***/

/*** Function To Convert Millimeters To Pixels Based On Device DPI (or PPI) Start ***/
function mmToPixels(mm, dpi) {
    return ((dpi * mm) / 25.4).toFixed(2); // Return size in pixels rounded to 2 decimals
}
/*** Function To Convert Millimeters To Pixels Based On Device DPI (or PPI) End ***/

/*** Function To Convert Carats To Pixel Size Based On Device DPI Start ***/
function caratToPixelSize(caratWeight, dpi) {
    // Step 1: Convert carat to millimeters
    const mmSize = caratToMm(caratWeight);
    
    // Step 2: Convert millimeters to pixels based on device DPI
    let pixelSize = mmToPixels(mmSize, dpi);
    
    // Optional: Apply scaling factor for visual purposes
    // let scalingFactor = 2; // Adjust this factor based on the size you want
    // pixelSize *= scalingFactor;
    
    // return pixelSize;
    return pixelSize *= 1, pixelSize;
}
/*** Function To Convert Carats To Pixel Size Based On Device DPI End ***/

/*** Get Gallery Canvas Image Layout ***/
function getCanvasLayout(diamondData) {
    var shape = diamondData.shape;
    var gridle = diamondData.girdle;
    if(gridle == '' || gridle == 'undefined' || gridle == 'Undefined' || gridle == null   || gridle == "null" ){
      if(diamondData.girdleMin != '' && diamondData.girdleMax != '' && diamondData.girdleMin != 0 && diamondData.girdleMax != 0){
        gridle = diamondData.girdleMin+"-"+diamondData.girdleMax;
      }else{
        gridle = "-";
      }      
    }
      
   var height = diamondData.depth;
   var dia_length = diamondData.length;
   var dia_width = diamondData.width;
   var dia_carat = diamondData.caratWeight;
   var culet = diamondData.culet;
   var width = diamondData.width;
   var length = diamondData.length;
   var depth = diamondData.depth;  
   var deptPerc = diamondData.deptPerc; 
   var table = diamondData.tablePerc;

   if(shape=='Round'){
      var table_width='195';
      var table_height='38';
      var depth_width='310';
      var depth_height='130';
      var depth_per_width='80';
      var depth_per_height='150';
      var gridle_width='101';
      var gridle_height='210';
      var culet_width='190';
      var culet_height='220';
      var width_height='17';
      var width_width='194';
      var length_height='145';
      var length_width='65';
    }

    if(shape=='Princess'){
      var table_width='200';
      var table_height='35';
      var depth_width='315';
      var depth_height='147';
      var depth_per_width='70';
      var depth_per_height='160';
      var gridle_width='112';
      var gridle_height='210';
      var culet_width='220';
      var culet_height='210'; 
      var width_height='15';
      var width_width='185';
      var length_height='145';
      var length_width='45';
    }

    if(shape=='Cushion' || shape=='Cushion Modified' || shape == 'Cushion Brilliant'){ 
      var table_width='185';
      var table_height='32';
      var depth_width='290';
      var depth_height='155';
      var depth_per_width='60';
      var depth_per_height='155';
      var gridle_width='120';
      var gridle_height='220';
      var culet_width='210';
      var culet_height='215';    
      var width_height='19';
      var width_width='190';
      var length_height='145';
      var length_width='50';
    }

    if(shape=='Radiant'){
      var table_width='200';
      var table_height='34';
      var depth_width='310';
      var depth_height='147';
      var depth_per_width='85';
      var depth_per_height='160';
      var gridle_width='140';
      var gridle_height='220';
      var culet_width='210';
      var culet_height='215'; 
      var width_height='14';
      var width_width='190';
      var length_height='145';
      var length_width='48';
    }

    if(shape=='Asscher'){
      var table_width='200';
      var table_height='35';
      var depth_width='315';
      var depth_height='148';
      var depth_per_width='70';
      var depth_per_height='160';
      var gridle_width='112';
      var gridle_height='210';
      var culet_width='220';
      var culet_height='210'; 
      var width_width='180';
      var width_height='15';
      var length_height='145';
      var length_width='42';
    }

    if(shape=='Emerald'){
      var table_width='200';
      var table_height='40';
      var depth_width='300';
      var depth_height='145';
      var depth_per_width='50';
      var depth_per_height='145';
      var gridle_width='110';
      var gridle_height='200';
      var culet_width='210';
      var culet_height='205'; 
      var width_width='190';
      var width_height='12';
      var length_height='145';
      var length_width='60';
    }

    if(shape=='Oval'){ 
      var table_width='200';
      var table_height='47';
      var depth_width='305';
      var depth_height='140';
      var depth_per_width='60';
      var depth_per_height='140';
      var gridle_width='112';
      var gridle_height='200';
      var culet_width='220';
      var culet_height='195'; 
      var width_width='200';
      var width_height='17';
      var length_height='150';
      var length_width='80';
    }

    if(shape=='Pear'){
      var table_width='210';
      var table_height='45';
      var depth_width='310';
      var depth_height='140';
      var depth_per_width='60';
      var depth_per_height='140';
      var gridle_width='124';
      var gridle_height='200';
      var culet_width='245';
      var culet_height='195'; 
      var width_width='195';
      var width_height='15';
      var length_height='145';
      var length_width='85';
    }

    if(shape=='Marquise'){ 
      var table_width='200';
      var table_height='47';
      var depth_width='305';
      var depth_height='140';
      var depth_per_width='60';
      var depth_per_height='140';
      var gridle_width='120';
      var gridle_height='200';
      var culet_width='210';
      var culet_height='200'; 
      var width_width='192';
      var width_height='17';
      var length_height='145';
      var length_width='85';
    }

    if(shape=='Heart'){
      var table_width='210';
      var table_height='32';
      var depth_width='290';
      var depth_height='155';
      var depth_per_width='60';
      var depth_per_height='155';
      var gridle_width='132';
      var gridle_height='215';
      var culet_width='240';
      var culet_height='210'; 
      var width_width='185';
      var width_height='18';
      var length_height='145';
      var length_width='60';
    }

    if(shape=='Square'){
      var table_width='200';
      var table_height='43';
      var depth_width='300';
      var depth_height='145';
      var depth_per_width='50';
      var depth_per_height='145';
      var gridle_width='110';
      var gridle_height='200';
      var culet_width='210';
      var culet_height='205';
      var width_width='200';
      var width_height='17';
      var length_height='145';
      var length_width='65';
    }
   
    drawCanvasSide(shape,table,gridle,culet,deptPerc,table_width,table_height,depth_width,depth_height,depth_per_width,depth_per_height,gridle_width,gridle_height,culet_width,culet_height,width,height);
    drawCanvasFront(shape,table,gridle,culet,depth,dia_width,dia_length,table_width,table_height,depth_width,depth_height,depth_per_width,depth_per_height,gridle_width,gridle_height,culet_width,culet_height,width,height, width_height, width_width, length_width, length_height);
}
/*** End ***/

/*** Draw Diamond Canvas Side Image ***/
function drawCanvasSide(shape,table,gridle,culet,deptPerc,table_width,table_height,depth_width,depth_height,depth_per_width,depth_per_height,gridle_width,gridle_height,culet_width,culet_height,width,height) {

    var circle_canvas = document.getElementsByClassName("tps-canvas-image-side")[0]; 
    
    var context = circle_canvas.getContext("2d");
      
    var depth1;
    if(height==''){
      depth1 = width;
    } else {
      depth1 = height;	
    }
  
    if(culet==''){
      culet='None';
    }
  
    // if(gridle==''){
    //   gridle='';
    // }	
    
    // Fill Style
    context.fillStyle = "rgb(0,0,0,0.80)";
      
    // Begin path
    context.beginPath();

    var img = new Image();
    img.src = $(".tps-canvas-thumb-image-side").attr('src');    
    img.onload = function() {  
      context.canvas.height = this.height;
      context.canvas.width = this.width;
      context.drawImage(img, 0, 0);
      context.font = "50px/bold open sans, arial"; 
      context.fillStyle = "#000000";
      context.fillText(table, table_width, table_height);
      context.fillText(deptPerc, depth_width, depth_height);
      context.fillText(gridle, gridle_width, gridle_height);
      // if(shape=='Marquise'){ 
      //   context.fillText(culet, culet_width, culet_height);
      // }
  };  
} 
/*** End ***/

/*** Draw Diamond Canvas Front Image ***/
function drawCanvasFront(shape,table,gridle,culet,depth,dia_width,dia_length,table_width,table_height,depth_width,depth_height,depth_per_width,depth_per_height,gridle_width,gridle_height,culet_width,culet_height,width,height, width_height, width_width, length_width, length_height) {

  var circle_canvas = document.getElementsByClassName("tps-canvas-image-front")[0];

  var context = circle_canvas.getContext("2d");

  var depth1;

  if(height==''){ 
    depth1=width;
  }else{ 
    depth1=height;   
  }  

  if(culet==''){ 
    culet='None'; 
  }

  if(gridle==''){ 
    gridle='-';
  } 

  // Fill Style
  context.fillStyle = "rgb(93,179,195,0.20)"; 
  context.beginPath();  
  
  var img = new Image();
  img.src =$(".tps-canvas-thumb-image-front").attr('src'); 
  img.onload = function() {             
    context.canvas.height = this.height;
    context.canvas.width = this.width;
    context.drawImage(img, 0, 0); 
    context.font = "50px/bold open sans, arial"; 
    context.fillStyle = "#000000";
    context.fillText(dia_width, width_width, width_height); 
    context.fillText(dia_length, length_width, length_height); 
  };
}
/*** End ***/

/*** Gallery Thumbnail Slider Script Code Start ***/
function galleryThumbnailSlider(verticalSlider){
    $('.tps-main-image-slide').slick({
       slidesToShow: 1,
       slidesToScroll: 1,
       infinite: true,
       arrows: true,       
       adaptiveHeight: true,
       asNavFor: '.tps-thumb-image-slide',
       draggable: false,
       lazyLoad: 'progressive',
   });

  if(verticalSlider == true){
      $('.tps-thumb-image-slide').slick({
         vertical: true,
         verticalSwiping: true,
         slidesToShow: 4,
         slidesToScroll: 1,
         infinite: false,
         asNavFor: '.tps-main-image-slide',        
         focusOnSelect: true,
         draggable: false, 
         arrows: true,
         lazyLoad: 'progressive',
     });
  }else{
      $('.tps-thumb-image-slide').slick({
         slidesToShow: 5,
         slidesToScroll: 1,
         infinite: true,
         asNavFor: '.tps-main-image-slide',
         dots: false,
         arrows: false,     
         // variableWidth: true,
         focusOnSelect: true,
         draggable: false,
         lazyLoad: 'progressive',
         responsive 		: [
		  		{
			      	breakpoint: 1440,
			      	settings: {
			        	slidesToShow 	: 4,
			        	slidesToScroll 	: 1,
			        	adaptiveHeight  : true,			        	
			      	}
			    },
		  		{
			      	breakpoint: 992,
			      	settings: {
			        	slidesToShow 	: 5,
			        	slidesToScroll 	: 1,
			        	adaptiveHeight  : true,			        	
			      	}
			    },
		  		{
			      	breakpoint: 768,
			      	settings: {
			        	slidesToShow 	: 5,
			        	slidesToScroll 	: 1,
			        	adaptiveHeight  : true,			        	
			      	}
			    },
			    {
			      	breakpoint: 640,
			      	settings: {
			        	slidesToShow 	: 4,
			        	slidesToScroll 	: 1,
			        	adaptiveHeight  : true,			        	
			      	}
			    },
			    {
			      	breakpoint: 581,
			      	settings: {
			        	slidesToShow 	: 4,
			        	slidesToScroll 	: 1,
			        	adaptiveHeight  : true,			        	
			      	}
			    },
		 	], 
     });
  }
   
}
/*** End ***/

/*** Diamond Four C's Section Script ***/
function diamondFourCSection(diamondData){
  var diamondType = diamondData.diamondType;
  var diamondcarat = parseFloat(diamondData.caratWeight);
  var diamondshape = diamondData.shape.toLowerCase();
  
  var carat_array = ['0.10-0.5','0.5-1','1-2','2-3','3-4','4-5','5-6','6-7','7-8','8-9','9-10'];
  //console.log(diamondcarat);
  $(".tps-carat-icon").addClass('tps-carat-icon-'+diamondshape);
  $(carat_array).each(function(index, caratvalue) { 
    var carat = caratvalue.split('-');
    var carat_min = parseFloat(carat[0]);
    var carat_max = parseFloat(carat[1]);
    carat_min = carat_min.toFixed(2);
    carat_max = carat_max.toFixed(2);
    
    if(diamondcarat == carat_min){
      var carat_min = carat_min.replace('.', '-');
      $(".tps-four-cs-carat-weight-ranges .tps-carat-"+carat_min).addClass('active');
    }else if(diamondcarat == carat_max){
      var carat_max = carat_max.replace('.', '-');
      $(".tps-four-cs-carat-weight-ranges .tps-carat-"+carat_max).addClass('active');
    }else if(diamondcarat >= carat_min && diamondcarat <= carat_max){
      var carat_min = carat_min.replace('.', '-');
      $(".tps-four-cs-carat-weight-ranges .tps-carat-"+carat_min).addClass('active'); 
      $(".tps-four-cs-carat-weight-ranges .tps-carat-"+carat_min).addClass('pointer'); 
      $(".tps-four-cs-carat-weight-ranges .tps-carat-"+carat_min+" .tps-carat-pointer-bx").html('<div class="tps-carat-val"><span>'+diamondcarat+'</span></div>');
    }    
    
  });        
  $("#tps_dia_carat_weight").html(diamondData.caratWeight);

  if(diamondData.fancyColor == ''){
     $("#tps_dia_color").html(diamondData.color);
     $(".tps-color-"+diamondData.color).addClass('active');
     $(".tps-four-cs-fancy-color-section").remove();
     // Remove the fancy color accordion for regular colored diamonds
     $("[id^='Details-fancy-color-']").closest('.tps-four-cs-accordion').remove();
  }else{
    $("#tps_dia_fancy_color").html(diamondData.fancyColor);
    $(".tps-fancy-color-"+diamondData.fancyColor).addClass('active');
    $(".tps-four-cs-color-section").remove();
    // Remove the regular color accordion for fancy colored diamonds
    $("[id^='Details-color-']").closest('.tps-four-cs-accordion').remove();
  }    

  if(diamondData.shape == "Round"){
    var diamondCut = diamondData.cut;
    $("#tps_dia_cut").html(diamondData.cut);
    if (diamondCut.indexOf("Very ") >= 0){
      diamondCut = diamondCut.replace(' ','-');
      $(".tps-cut-"+diamondCut).addClass('active');
    }else{
      $(".tps-cut-"+diamondCut).addClass('active');
    }
  }else{
    // Remove the entire cut accordion for non-round diamonds
    $("[id^='Details-cut-']").closest('.tps-four-cs-accordion').remove();
  }      
  
  $("#tps_dia_clarity").html(diamondData.clarity);
  $(".tps-clarity-"+diamondData.clarity).addClass('active');
}
/*** End ***/


function createDiamondProduct(diamond_type){    
 
  if(diamond_type == 'white'){
    var diamondAddToCart = rapnetDiamondAddToCart;
  }else{
    var diamondAddToCart = labDiamondAddToCart;
  }
  jQuery("#tps_add_diamond_to_wishlist").addClass('tps-loading');
  var diamond_image = jQuery('.tps-diamond-stock-image').attr('src');
      
  //query parameters for graphql diamond add to cart call
  var postdata = JSON.stringify({ query:`{
                  ${diamondAddToCart}(diamondId: "` +
              diamond_id +
              `",diamondImage:"` +
              diamond_image +
              `")
                  {      
                    status
                     code
                     message                       
                     productId
                     variantId                     
                  }
                  }
                  `});     

     jQuery.ajax({
      url:api,
      contentType: "application/json",
      type:'POST',
      data: postdata,
      success: function(response) { 
        if(diamond_type == 'white'){
          var productId = response.data.rapnetDiamondAddToCart.productId;  
        }else{
          var productId = response.data.diamondAddToCart.productId;       
        }
        
        setTimeout(function(){ 
            addRemoveProductToWishlist(productId,'diamond');
            jQuery("#tps_add_diamond_to_wishlist").removeClass('tps-loading');
            
        }, 1500); 
      },
      error: function (xhr, ajaxOptions, thrownError) {
         alert(xhr.status);
         alert(thrownError);           
         jQuery("#tps_add_diamond_to_wishlist").removeClass('tps-loading');
       }
    }); 
}
/*** End ***/